define([
	"dojo/_base/declare",
	"./StyleAttributeId"
], function(declare,StyleAttributeId) {

	return declare(StyleAttributeId, {
		sourceClassName: "Shape"
	});
});
